import { CardType } from '@websky/core/src/PromoLoader/types';
import { getLocale } from '@websky/core/src/utils';
import { Locale } from '@websky/core/src/types';
import { BaggageType, OauthServiceType } from '@websky/graphql';
const locale = getLocale();
const isProd = process.env.NODE_ENV === 'production';
const currentLocale = locale === Locale.Russian ? '' : `${locale}/`;
export const companyInfo = {
    facebook: '',
    instagram: '',
    vk: 'https://vk.com/aurora.airlines',
    baggage: 'https://www.flyaurora.ru/information/carriage-rules/transportation-of-baggage-and-hand-luggage/',
    meal: 'https://www.flyaurora.ru/services/passengers/meals-on-board/',
    seat: 'https://www.flyaurora.ru/services/passengers/the-choice-of-location/',
    privacyPolicy: 'https://www.flyaurora.ru/information/passengers/protection-of-privacy/',
    exarePrivacyPolicyURL: 'https://www.flyaurora.ru/information/passengers/contract-carriage/',
    exareRulesURL: 'https://www.flyaurora.ru/information/passengers/rules-fare-application/',
    insurance: 'https://www.flyaurora.ru/services/passengers/additional-insurance/',
    loyaltyProgramRegistrationUrl: ``,
    loyaltyProgramName: '',
    iataCode: 'HZ',
    loyalty: {
        links: [
            {
                title: 'Status',
                url: ``
            },
            {
                title: 'Earn miles',
                url: ``
            },
            {
                title: 'Use miles',
                url: ``
            },
            {
                title: 'FAQ',
                url: ``
            }
        ]
    },
    multiInsurance: true,
    specialDocumentForInsurance: true,
    legal: `https://www.flyaurora.ru/${currentLocale}information/passengers/rules-fare-application/`
};
const locales = {
    ru: {
        Contacts: {
            'Log in': 'Ввести код'
        },
        SeatMap: {
            SeatMap_Standard: 'Эконом'
        },
        translation: {
            'Local time': 'Цены указаны для всех пассажиров, включая налоги и сборы. Время местное'
        },
        LoginPage: {
            'Email / Phone / Card number': 'Эл. почта',
            'Please enter a valid Email / Phone / Card number': 'Пожалуйста введите Эл. почту'
        },
        Account: {
            'Online check-in opens 30 hours and closes 50 minutes before departure': 'Онлайн-регистрация открывается за 24 часа и заканчивается за 3 часа до вылета рейса.',
            CheckinConditions_1: 'Онлайн-регистрация открывается за 24 часа и заканчивается за 45 минут до вылета рейса',
            CheckinConditions_2: 'Пожалуйста, убедитесь, что вес и габариты ручной клади соответствуют Правилам перевозок',
            CheckinConditions_3: ' '
        },
        AdditionalBaggage: {
            'Buy now and save 20-30%': 'Сэкономьте сейчас 20-30% (скидка применяется при оплате превышения количества мест)'
        },
        PaymentForm: {
            Invoicebox: 'Оплата по счету для Юридических лиц'
        },
        PromoCode: {
            'Do you have a promo code?': 'Ввести промокод'
        },
        RetrieveBooking: {
            'Security code': 'Фамилия пассажира',
            'You can find security code in your booking confirmation email': 'Фамилию пассажира можно найти в электронном письме о подтверждении бронирования'
        },
        SearchForm: {
            'Pay by miles': 'Купить за мили',
            Dates: 'Даты',
            'Set multi city route': 'Задать сложный маршрут',
            'Offer hotels': 'Искать отели'
        },
        Results: {
            'Show price diagram': 'Диаграмма цен',
            'Selected flights': 'Выбрано'
        },
        translation: {
            'Local time': 'Цена для всех пассажиров. Указано местное время.',
            'We couldn\'t find any flights for given dates': 'В выбранную дату рейс не выполняется или на рейсе нет свободных мест',
            'If the flight is operating on the selected date, but there are no available seats, you can use the free “Waiting List” service by calling phone number 0065': 'В случае, если в выбранную дату рейс выполняется, но отсутствуют свободные места, вы можете воспользоваться бесплатной услугой «Лист ожидания» позвонив по номеру телефона *0065'
        },
        DesktopFlightInfo: {
            'Select from': 'от'
        },
        FareLock: {
            'Lock fare': 'Зафиксировать, всего',
            only: 'всего за',
            'Fixation the cost of the air ticket': 'Гарантированная цена - зафиксировать стоимость авиабилета!',
            'No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}': `Боитесь, что билеты раскупят или вырастут в цене?\n Зафиксируйте цену на {{hours}} {{plural}}!`
        },
        Checkout: {
            Agreement: '<span>Я согласен с  <a target="_blank" class="link" href="https://www.flyaurora.ru/information/passengers/rules-fare-application/">условиями договора</a>, разрешаю обработку и хранение персональных данных. <a target="_blank" class="link" href="https://www.flyaurora.ru/information/passengers/covid-19/">C ограничениями на въезд из-за COVID я ознакомился (-лась)</a></span>',
            'authorize the processing and storage of personal data': 'разрешаю обработку и хранение персональных данных',
            'Now you have a Personal Account {{email}}': 'Теперь у вас есть Личный кабинет {{email}}',
            'Track flights': 'Отслеживайте рейсы',
            'Get notifications': 'Получайте уведомления',
            'Correspond with the airline': 'Переписывайтесь с авиакомпанией',
            'Get discounts': 'Получайте скидки',
            'Add travel companions': 'Добавляйте попутчиков',
            'Login from any device': 'Заходите с любого устройства',
            'Open Personal Account': 'Открыть Личный кабинет'
        },
        PromoLoader: {
            'If you want to enjoy the scenery, take amazing pictures or show your child the indescribable beauty of nature overboard the plane, as well as the moment of takeoff and landing, then choose a seat near the window. Or you can choose an aisle seat and be able to warm up during the flight without disturbing other passengers': 'Желаете любоваться пейзажами, делать потрясающие снимки или же показать ребенку неописуемую красоту природы за бортом самолёта, а также момент взлёта и посадки -тогда выбирайте место возле окна. Либо можете выбрать место у прохода и иметь возможность размяться во время полета и не тревожить других пассажиров.',
            '20% cheaper! When paying for Excess Baggage on the website of the Airline': 'Дешевле на 20%! При оплате Сверхнормативного багажа на сайте Авиакомпании',
            'In order not to be bored in flight, use the Aurora Entertainment entertainment system!': 'Чтобы не было скучно в полёте – пользуйтесь системой развлечений Aurora Entertainment!',
            'Souvenirs for those who are in love with the sky...': 'Сувениры для тех, кто влюблён в небо…',
            'More legroom means more comfort in flight!': 'Больше пространства для ног – больше комфорта в полёте!',
            'Location selection': 'Выбор места',
            'Excess baggage': 'Сверхнормативный багаж',
            'Entertainment system': 'Система развлечений',
            'Souvenir products': 'Сувенирная продукция',
            'Space+': 'Space+'
        },
        Exchange: {
            'You’ve chosen': 'Вы выбрали',
            'Change flight': 'Изменить',
            'After submitting the request, the seats you have selected will be canceled.': 'As soon as you confirm your intention to make a refund, the seats reserved for transportation are automatically canceled by the booking system on all unused sections of the route. This action has no retroactive effect. The refund request will be processed in the near future. If you have any questions, please call 88002504988.',
            'The possibility and amount of refund will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.': 'The possibility and amount of refund is calculated by the operator after sending the application. The terms of the tariff for voluntary refund apply! Forced refund in case of cancellation or flight delay!',
            'Возможность и сумма возврата рассчитываются оператором после отправки заявки. Ответ будет отправлен на вашу электронную почту, а также доступен на странице заказа.': 'Возможность и сумма возврата рассчитываются оператором после отправки заявки. Применяются условия тарифа для добровольного возврата! Вынужденный возврат в случае отмены, задержки рейса!',
            'После отправки запроса выбранные вами места будут аннулированы.': 'Как только Вы подтверждаете свои намерения сделать возврат, забронированные для перевозки места автоматически аннулируются системой бронирования на всех неиспользованных участках маршрута. Обратной силы данное действие не имеет. Заявка на возврат будет обработана в ближайшее время. При возникновении вопросов, обращайтесь по телефону 88002504988.'
        },
        FlightCard: {
            'Flight operated by': 'Рейс выполняет'
        },
        Consents: {
            agreement_rules: 'Я ознакомился(-лась) с {{links}}.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">правилами страхования</a>, {{insurancesProductsLinks}}',
            agreement_gdsRules: '<span><a href="https://www.flyaurora.ru/services/" target="_blank">условиями предоставления услуг</a></span>',
            agreement_interpolation: `{{additionalServiceRules}}{{insurancesRules}}{{petsRules}}{{endRules}}`,
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'условиями публичной оферты «{{name}}»',
            agreement_additionalInsuranceRulesLink: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">правила страхования</a>',
            agreement_petsRules: '<a href="https://www.flyaurora.ru/information/carriage-rules/transportation-animals/" target="_blank">правилами перевозки животных</a>',
            agreement_endRules: ', оплатой данных доп. услуг, принимаю их и согласен с ними'
        },
        FlightPrice: {
            '{{count}} {{ticket}} {{left}}': 'по этой цене {{left}} {{count}} {{ticket}}'
        },
        Title: {
            companyName: 'Aurora'
        },
        Contacts: {
            'Enter the code sent to the email for access to booking': 'Введите код, отправленный на почту, чтобы не потерять доступ к вашему бронированию ',
            'Enter code': 'Ввести код'
        },
        Refund: {
            'The money will be returned to the card used to pay for the ticket within 15 days': 'Деньги будут возвращены на карту, использованную при оплате билета, в течение 30 дней после проведения возврата.'
        },
        OrderCard: {
            'Passengers details': 'Данные пассажиров'
        }
    },
    en: {
        LoginPage: {
            'Email / Phone / Card number': 'Email',
            'Please enter a valid Email / Phone / Card number': 'Please enter a valid Email'
        },
        Account: {
            'Online check-in opens 30 hours and closes 50 minutes before departure': 'Online check-in opens 24 hours and closes 3 hours before departure',
            CheckinConditions_1: 'Online check-in opens 30 hours and closes 45 minutes before departure',
            CheckinConditions_2: 'Please make sure that the weight and dimensions of the hand luggage comply with the transportation rules',
            CheckinConditions_3: ' '
        },
        AdditionalBaggage: {
            'Buy now and save 20-30%': 'Buy now and save 20-30% (discount applied when paying for excess number of seats)'
        },
        RetrieveBooking: {
            'Security code': 'Last name of the passenger',
            'You can find security code in your booking confirmation email': 'Last name you can find in your booking confirmation email'
        },
        PaymentForm: {
            Invoicebox: 'Payment by invoice for legal entities'
        },
        Results: {
            'Show price diagram': 'Price diagram',
            'Selected flights': 'Selected'
        },
        translation: {
            'Local time': 'The specified cost is for all passengers. Local time.',
            'It looks like something went wrong': 'Sorry, there is no flight on that day or there are no seats on this flight',
            'We couldn\'t find any flights for given dates': 'Sorry, there is no flight on that day or there are no seats on this flight',
            'If the flight is operating on the selected date, but there are no available seats, you can use the free “Waiting List” service by calling phone number 0065': 'If the flight is operating on the selected date, but there are no available seats, you can use the free «Waiting List» service by calling phone number *0065'
        },
        DesktopFlightInfo: {
            'Select from': 'from'
        },
        FareLock: {},
        Checkout: {
            Agreement: '<span>I agree with the <a target="_blank" class="link-23a2K" href="https://www.flyaurora.ru/information/passengers/rules-fare-application/">terms of the agreement</a>, I authorize the processing and storage of personal data. <a target="_blank" class="link-23a2K" href="https://www.flyaurora.ru/information/passengers/covid-19/">I have read the entry restrictions due to COVID</a></span>',
            'authorize the processing and storage of personal data': 'authorize the processing and storage of personal data',
            'Now you have a Personal Account {{email}}': 'Now you have a Personal Account {{email}}',
            'Track flights': 'Track flights',
            'Get notifications': 'Get notifications',
            'Correspond with the airline': 'Correspond with the airline',
            'Get discounts': 'Get discounts',
            'Add travel companions': 'Add travel companions',
            'Login from any device': 'Login from any device',
            'Open Personal Account': 'Open Personal Account'
        },
        PromoLoader: {
            'If you want to enjoy the scenery, take amazing pictures or show your child the indescribable beauty of nature overboard the plane, as well as the moment of takeoff and landing, then choose a seat near the window. Or you can choose an aisle seat and be able to warm up during the flight without disturbing other passengers': 'If you want to enjoy the scenery, take amazing pictures or show your child the indescribable beauty of nature overboard the plane, as well as the moment of takeoff and landing, then choose a seat near the window. Or you can choose an aisle seat and be able to warm up during the flight without disturbing other passengers',
            '20% cheaper! When paying for Excess Baggage on the website of the Airline': '20% cheaper! When paying for Excess Baggage on the website of the Airline',
            'In order not to be bored in flight, use the Aurora Entertainment entertainment system!': 'In order not to be bored in flight, use the Aurora Entertainment entertainment system!',
            'Souvenirs for those who are in love with the sky...': 'Souvenirs for those who are in love with the sky...',
            'More legroom means more comfort in flight!': 'More legroom means more comfort in flight!',
            'Location selection': 'Location selection',
            'Excess baggage': 'Excess baggage',
            'Entertainment system': 'Entertainment system',
            'Souvenir products': 'Souvenir products',
            'Space+': 'Space+'
        },
        Exchange: {
            'You’ve chosen': 'You’ve chosen',
            'Change flight': 'Change flight'
        },
        FlightCard: {
            'Flight operated by': 'Flight operated by'
        },
        Consents: {
            agreement_rules: 'I have read the {{links}}.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_gdsRules: '<span><a href="https://www.flyaurora.ru/services/" target="_blank">rules of additional services</a></span>',
            agreement_interpolation: `{{additionalServiceRules}}{{insurancesRules}}`,
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»',
            agreement_additionalInsuranceRulesLink: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">rules of insurance</a>',
            agreement_petsRules: '<a href="https://www.flyaurora.ru/information/carriage-rules/transportation-animals/" target="_blank">rules of transporting pets</a>',
            agreement_endRules: ', payment terms of these additional services. I accept them and agree with them'
        },
        Title: {
            companyName: 'Aurora'
        },
        Contacts: {
            'Enter the code sent to the email for access to booking': 'Enter the code sent to the email for access to booking',
            'Enter code': 'Enter code'
        },
        Refund: {
            'The money will be returned to the card used to pay for the ticket within 15 days': 'The money will be returned to the card used to pay for the ticket within 30 days after refund.'
        },
        SearchForm: {
            'Offer hotels': 'Search for hotels'
        }
    },
    de: {
        Consents: {
            agreement_rules: 'I have read the {{links}}.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_gdsRules: '<span><a href="https://www.flyaurora.ru/services/" target="_blank">rules of additional services</a></span>',
            agreement_interpolation: `{{additionalServiceRules}}{{insurancesRules}}`,
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»',
            agreement_additionalInsuranceRulesLink: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">rules of insurance</a>',
            agreement_petsRules: '<a href="https://www.flyaurora.ru/information/carriage-rules/transportation-animals/" target="_blank">rules of transporting pets</a>',
            agreement_endRules: ', payment terms of these additional services. I accept them and agree with them'
        },
        Title: {
            companyName: 'Aurora'
        }
    },
    fr: {
        Consents: {
            agreement_rules: 'I have read the {{links}}.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_gdsRules: '<span><a href="https://www.flyaurora.ru/services/" target="_blank">rules of additional services</a></span>',
            agreement_interpolation: `{{additionalServiceRules}}{{insurancesRules}}`,
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»',
            agreement_additionalInsuranceRulesLink: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">rules of insurance</a>',
            agreement_petsRules: '<a href="https://www.flyaurora.ru/information/carriage-rules/transportation-animals/" target="_blank">rules of transporting pets</a>',
            agreement_endRules: ', payment terms of these additional services. I accept them and agree with them'
        },
        Title: {
            companyName: 'Aurora'
        }
    },
    kk: {
        Consents: {
            agreement_rules: 'I have read the {{links}}.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_gdsRules: '<span><a href="https://www.flyaurora.ru/services/" target="_blank">rules of additional services</a></span>',
            agreement_interpolation: `{{additionalServiceRules}}{{insurancesRules}}`,
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»',
            agreement_additionalInsuranceRulesLink: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">rules of insurance</a>',
            agreement_petsRules: '<a href="https://www.flyaurora.ru/information/carriage-rules/transportation-animals/" target="_blank">rules of transporting pets</a>',
            agreement_endRules: ', payment terms of these additional services. I accept them and agree with them'
        },
        Title: {
            companyName: 'Aurora'
        }
    },
    zh: {
        Consents: {
            agreement_rules: 'I have read the {{links}}.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_gdsRules: '<span><a href="https://www.flyaurora.ru/services/" target="_blank">rules of additional services</a></span>',
            agreement_interpolation: `{{additionalServiceRules}}{{insurancesRules}}`,
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»',
            agreement_additionalInsuranceRulesLink: '<a href="https://www.alfastrah.ru/docs/insurance_passengers_rules_284.pdf" target="_blank">rules of insurance</a>',
            agreement_petsRules: '<a href="https://www.flyaurora.ru/information/carriage-rules/transportation-animals/" target="_blank">rules of transporting pets</a>',
            agreement_endRules: ', payment terms of these additional services. I accept them and agree with them'
        },
        Title: {
            companyName: 'Aurora'
        }
    }
};
const promoLoaders = [
    {
        type: CardType.Seats,
        title: 'Location selection',
        text: 'If you want to enjoy the scenery, take amazing pictures or show your child the indescribable beauty of nature overboard the plane, as well as the moment of takeoff and landing, then choose a seat near the window. Or you can choose an aisle seat and be able to warm up during the flight without disturbing other passengers',
        image: 'https://cdn.websky.aero/content/HZ/images/Loaders/place-choice.png'
    },
    {
        type: CardType.Meal,
        title: 'Excess baggage',
        text: '20% cheaper! When paying for Excess Baggage on the website of the Airline',
        image: 'https://cdn.websky.aero/content/HZ/images/Loaders/baggage.jpg'
    },
    {
        type: CardType.Aircraft,
        title: 'Entertainment system',
        text: 'In order not to be bored in flight, use the Aurora Entertainment entertainment system!',
        image: 'https://cdn.websky.aero/content/HZ/images/Loaders/entertainment.jpg'
    },
    {
        type: CardType.WiFi,
        title: 'Souvenir products',
        text: 'Souvenirs for those who are in love with the sky...',
        image: 'https://cdn.websky.aero/content/HZ/images/Loaders/shop.jpg'
    },
    {
        type: CardType.City,
        title: 'Space+',
        text: 'More legroom means more comfort in flight!',
        image: 'https://cdn.websky.aero/content/HZ/images/Loaders/seat-choice.jpg'
    }
];
export const config = {
    global: {
        authMethods: {
            ffp: false
        },
        socialAuthMethods: [
            {
                service: OauthServiceType.Vkontakte,
                isAvailable: true
            }
        ],
        seatMap: {
            splitByCabin: true
        },
        showIsActualizationResultOk: false,
        companyInfo,
        maxBaggagePerPassenger: 50,
        // allowPromoCodes: true,
        i18n: locales,
        dynamicBaggagePricing: true,
        baggage: {
            baggageLimit: {
                maxBaggagePerPassenger: 50,
                baggageByTypeLimit: [
                    {
                        baggageType: BaggageType.CheckedBaggage,
                        maxBaggagePerPassenger: 50
                    }
                ]
            }
        },
        insurance: {
            upsaleStrategy: ['checkout-insurance-step'],
            allowImplicitConfirm: true
        }
    },
    Engine: {
        searchFormURL: isProd ? './' : null,
        calendarDaysCount: 5,
        promoLoaders,
        sortResultPreferCurrentAirline: true
    },
    SearchForm: {
        showPriceGraph: true,
        enableComplexRoute: true,
        // payByMiles: true,
        showPricesInDatepicker: true,
        offerHotels: true,
        offerHotelsSupplier: 'OSTROVOK',
        offerHotelsLink: 'https://hotels.flyaurora.ru/hotels/',
        offerHotelsMainLink: 'https://hotels.flyaurora.ru/'
    }
};
